import NotEnoughBricksModal from './NotEnoughBricksModal';

export default NotEnoughBricksModal;
